import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class Presentation extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get title() {
    try {
      return get(this, '_tytul.value', '');
    } catch (e) {
      console.log('Error', e);
      return null;
    }
  }

  get description() {
    try {
      return get(this, '_opis.value', '');
    } catch (e) {
      console.log('Error', e);
      return null;
    }
  }

  get url() {
    try {
      return get(this, '_url_slug.value', '');
    } catch (e) {
      console.log('Error', e);
      return null;
    }
  }

  get thumbnail() {
    try {
      return get(this, '_zdjecie.value', '');
    } catch (e) {
      console.log('Error', e);
      return null;
    }
  }

  get files() {
    try {
      return get(this, '_pliki.value', []);
    } catch (e) {
      console.log('Error', e);
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Presentation.model.js